

















































import {Watch, Component, Vue} from 'vue-property-decorator'
import {Meta} from '@sophosoft/vue-meta-decorator'
import {namespace} from 'vuex-class'
import {TableItem, TableHeaderItem} from '@/utils/types'
import {Survey} from '@/store/modules/lib'
import {uuid} from 'vue-uuid';

import QuestionBox from './QuestionBox.vue'
import QuestionBoxList, {IDraggableParamsExtend} from './QuestionBoxList.vue'
import DetailSideBar from './Details/DetailSideBar.vue'
import LfsRadioBox from './Details/LfsRadioBox.vue'
import Chip from '@/components/UI/Chip.vue'
import draggable from 'vuedraggable'

import IQuestion from '@/models/IQuestion'
import IAnswer from '@/models/IAnswer'
import {EventBus} from '@/event-bus'
import {TranslateResult} from 'vue-i18n'
import {NavigationGuardNext, RawLocation, Route} from 'vue-router'
import ISurvey from '@/components/icons/ISurvey.vue';
import PostSignature from '@/components/lfs/Survey/PostSignature.vue';


interface IQuestionBranchData {
  questionId: string
  answerId: string
  includeQuestions: string[]
}

interface PostModel {
  title:string,
  text: string,
  active?: boolean
}

interface Comment {
  title: string,
  text: string,
  order?: number | null
}

const auth = namespace('auth')
const surv = namespace('survey')
const appStore = namespace('app')

Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteUpdate',
  'beforeRouteLeave'
])

@Component({
  name: 'Page',
  components: {
  }
})
export default class SurveyDemo extends Vue {

}
